import { useEffect } from "react";

export default function PrivacyPolicyPage() {
  useEffect(() => {
    document.title = "Política de Privacidade - Fox Vendas";
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <div className="container mx-auto px-4 py-8 max-w-4xl">
        <h1 className="text-3xl font-bold text-foreground mb-8">
          Política de Privacidade
        </h1>
        
        <div className="prose prose-lg max-w-none text-foreground space-y-6">
          <p>
            A Fox Vendas, inscrita no CNPJ sob o nº 43.732.251/0001-73, com sede na Rua Alecrins, 940, sala 03, Cambuí, Campinas-SP, valoriza e respeita a privacidade de seus clientes, usuários e visitantes. Este documento tem como objetivo esclarecer quais informações coletamos, como as utilizamos e os direitos de cada usuário em relação a esses dados.
          </p>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              1. Informações Coletadas
            </h2>
            <p className="mb-4">Podemos coletar as seguintes informações:</p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Dados pessoais, como nome, telefone, e-mail, CPF e informações relacionadas a imóveis de interesse;</li>
              <li>Dados de navegação, como endereço IP, cookies e localização aproximada, para melhoria da experiência no site e em nossos sistemas.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              2. Finalidade do Uso dos Dados
            </h2>
            <p className="mb-4">As informações coletadas são utilizadas para:</p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Comunicação com clientes e leads;</li>
              <li>Agendamento de visitas e atendimento comercial;</li>
              <li>Envio de campanhas e materiais de marketing, quando autorizado;</li>
              <li>Aprimoramento contínuo da experiência do usuário.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              3. Compartilhamento de Dados
            </h2>
            <p className="text-muted-foreground mb-4">
              A Fox Vendas não comercializa os dados pessoais de seus usuários.
              O compartilhamento de informações pode ocorrer apenas com parceiros estratégicos, como plataformas de anúncios, serviços de pagamento e provedores de tecnologia, sempre de forma segura e respeitando a legislação vigente.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              4. Direitos do Usuário
            </h2>
            <p className="mb-4">O usuário tem direito a:</p>
            <ul className="list-disc list-inside space-y-2 text-muted-foreground">
              <li>Acessar, corrigir ou excluir seus dados pessoais;</li>
              <li>Solicitar a portabilidade dos dados;</li>
              <li>Revogar consentimento previamente concedido, a qualquer momento.</li>
            </ul>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              5. Segurança das Informações
            </h2>
            <p className="text-muted-foreground">
              Adotamos medidas técnicas e administrativas para proteger os dados pessoais contra acessos não autorizados, uso indevido, perda ou divulgação indevida.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              6. Alterações nesta Política
            </h2>
            <p className="text-muted-foreground">
              Esta Política de Privacidade poderá ser atualizada periodicamente.
              Sempre que houver mudanças significativas, os usuários serão informados por meio dos canais oficiais da Fox Vendas.
            </p>
          </section>

          <section>
            <h2 className="text-2xl font-semibold text-foreground mb-4">
              7. Contato
            </h2>
            <p className="text-muted-foreground">
              Em caso de dúvidas, solicitações ou para exercer seus direitos relacionados à privacidade, entre em contato pelo e-mail:{" "}
              <a 
                href="mailto:suporte@foxvendas.com.br" 
                className="text-primary hover:underline"
              >
                suporte@foxvendas.com.br
              </a>
            </p>
          </section>

          <section className="border-t border-border pt-8 mt-8">
            <h1 className="text-3xl font-bold text-foreground mb-6">
              Instruções para Exclusão de Dados
            </h1>
            
            <p className="text-muted-foreground mb-6">
              A Fox Vendas, inscrita no CNPJ sob o nº 43.732.251/0001-73, respeita o direito de todos os usuários de solicitar a exclusão de seus dados pessoais conforme previsto na Lei Geral de Proteção de Dados (LGPD).
            </p>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                1. Como solicitar a exclusão dos seus dados
              </h2>
              <p className="mb-4">Se você deseja excluir seus dados pessoais de nossos sistemas, siga os passos abaixo:</p>
              
              <p className="mb-4">
                Envie um e-mail para{" "}
                <a 
                  href="mailto:suporte@foxvendas.com.br" 
                  className="text-primary hover:underline"
                >
                  suporte@foxvendas.com.br
                </a>
                {" "}com o assunto: "Solicitação de Exclusão de Dados".
              </p>

              <p className="mb-4">No corpo do e-mail, informe:</p>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground mb-6">
                <li>Nome completo;</li>
                <li>CPF (quando aplicável);</li>
                <li>Telefone cadastrado;</li>
                <li>E-mail utilizado em nosso sistema;</li>
                <li>Breve descrição do motivo da solicitação (opcional).</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                2. Prazo para atendimento
              </h2>
              <p className="text-muted-foreground mb-4">
                Após o recebimento da solicitação, a Fox Vendas terá até 15 dias úteis para processar e concluir a exclusão, conforme determina a LGPD.
              </p>
              <p className="text-muted-foreground">
                Você receberá uma confirmação por e-mail quando a exclusão for finalizada.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                3. Importante saber
              </h2>
              <ul className="list-disc list-inside space-y-2 text-muted-foreground">
                <li>A exclusão pode afetar serviços ativos, como agendamentos ou histórico de atendimentos.</li>
                <li>Em alguns casos, determinados dados poderão ser mantidos por obrigação legal ou regulatória (ex.: documentos fiscais, contratos).</li>
                <li>Garantimos que, nesses casos, os dados serão armazenados apenas pelo período exigido em lei e de forma segura.</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold text-foreground mb-4">
                4. Contato
              </h2>
              <p className="text-muted-foreground">
                Se restarem dúvidas sobre o processo de exclusão ou sobre o uso de seus dados pessoais, entre em contato pelo e-mail{" "}
                <a 
                  href="mailto:suporte@foxvendas.com.br" 
                  className="text-primary hover:underline"
                >
                  suporte@foxvendas.com.br
                </a>
              </p>
            </section>
          </section>
        </div>
      </div>
    </div>
  );
}